module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bamboo-collection_85aa2a.jpg";